import React from "react";
import "./OurServices.css";
import pic1 from "./../../assets/images/pic1new.png";
import pic2 from "./../../assets/images/pic2new.png";
import pic3 from "./../../assets/images/pic3new.png";
import pic4 from "./../../assets/images/pic4new.png";
import pic5 from "./../../assets/images/pic5new.png";
import pic6 from "./../../assets/images/pic6new.png";
import Loader from "../Loader/Loader";
const OurServices = () => {
  const data = [
    {
      img: pic1,
      heading: "Door-to-door travel",
      text: "Rest easy with door-to-door pickup and drop-off — no change of transportation is needed.",
    },
    {
      img: pic2,
      heading: "Your safe passage",
      text: "Travel confidently knowing your safety is our #1 priority. Rigorous health and cleaning standards round out a best-in-class service.",
    },
    {
      img: pic3,
      heading: "Freedom of flexibility",
      text: "Schedule your pick-up whenever you want, and leave departure boards and timetables in the rear-view mirror.",
    },
    {
      img: pic4,
      heading: "Safety first",
      text:"The same trusted Health & Safety Standards and trained professionals at the wheel, but with added convenience."
    },
    {
      img: pic5,
      heading: "Competitive rates",
      text:"With set distance-based rates and no surge pricing you can, for example, hail a chauffeur in the for as little as £20."
    },
    {
      img: pic6,
      heading: "Seamless airport travel",
      text:"Relax with 1 hour of complimentary wait time and flight tracking."
    },
  ];

  return (
    <>
    <Loader/>
      <div className="mainOurServices">
        <div className="ourServiceTxt">Our Services</div>

        <div className="middleLine"></div>
        <div className="ourServTxtPara">
          It's reliable. Enjoy peace of mind with our proven reliability!
        </div>
      </div>

      <div className="mainOurServicesCard">
        <div className="mainOurServicesCardInner">
        {data?.map((item) => (
          <div className="cardOurServices">
            <img src={item.img} />
            <div className="headingTxtSerCard">{item.heading}</div>

            <div className="ourServiceCardTxt">{item.text}</div>
          </div>
        ))}
        </div>
       
      </div>
    </>
  );
};

export default OurServices;
